import { Box, Button, MenuItem, Select, Typography } from '@mui/material';
import { Gear, LockKey, LockKeyOpen } from '@phosphor-icons/react';
import React from 'react';
import PublishModal from '../PublishModal/PublishModal';
import AccessModal from '../PublishModal/AccessModal';
import ShareFormModal from '../PublishModal/ShareFormModal';
import IconButtonTooltip from '../../../components/UI/IconButtonTooltip/IconButtonTooltip';
import SettingsModal from '../PublishModal/SettingsModal';

type FormHeaderToolsProps = {
  flow: any;
  form: any;
  onSave: () => void;
  setFormPreviewOpen: (val: boolean) => void;
  setOpenPublishModal: (val: boolean) => void;
  setOpenAccessModal: (val: boolean) => void;
  setOpenShareModal: (val: boolean) => void;
  setUndoRedo: (val: any) => void;
  setForm: (val: any) => void;
  hasChanges: boolean;
  nodes: any;
  openPublishModal: boolean;
  openAccessModal: boolean;
  openShareModal: boolean;
  openSettingsModal: boolean;
  setOpenSettingsModal: (val: boolean) => void;
};

const FormHeaderTools = ({
  flow,
  form,
  onSave,
  setFormPreviewOpen,
  setOpenPublishModal,
  setOpenAccessModal,
  setOpenShareModal,
  setUndoRedo,
  setForm,
  hasChanges,
  nodes,
  openPublishModal,
  openAccessModal,
  openShareModal,
  openSettingsModal,
  setOpenSettingsModal,
}: FormHeaderToolsProps) => {
  return (
    <Box
      sx={{
        border: '1px solid #EAECF0',
        bgcolor: 'white',
        borderRadius: '8px',
        p: '12px 20px',
        display: 'flex',
        justifyContent: 'space-between',
        mb: '16px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
          w: '100%',
        }}
      >
        <Select value={'form'} sx={{}}>
          <MenuItem value="form">
            <Typography>{flow?.name ? flow?.name : 'Untitled Form'}</Typography>
          </MenuItem>
        </Select>

        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            alignItems: 'center',
            bgcolor: '#E7F0FF',
            p: '4px 8px',
            borderRadius: '4px',
            border: '1px solid #7388F7',
            cursor: 'pointer',
          }}
          color={'#3650DE'}
          onClick={() => {
            setOpenAccessModal(true);
            onSave();
          }}
        >
          {form?.publishType === 'internal' ? (
            <LockKey size={14} />
          ) : (
            <LockKeyOpen size={14} />
          )}
          <Typography
            sx={{
              lineHeight: '160%',
              textTransform: 'capitalize',
            }}
          >
            {form?.publishType}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            alignItems: 'center',
            bgcolor: form?.status === 'draft' ? '#FFF8E0' : '#E7F4E8',
            p: '4px 8px',
            borderRadius: '4px',

            color: form?.status === 'draft' ? '#FDA000' : '#378D3C',
            border: `1px solid  ${
              form?.status === 'draft' ? '#FED54D' : '#80C683'
            }`,
          }}
        >
          <Typography
            sx={{
              lineHeight: '160%',
              textTransform: 'capitalize',
            }}
          >
            {form?.status === 'draft' ? 'Unpublished' : 'Published'}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
        }}
      >
        <IconButtonTooltip
          onClick={() => setOpenSettingsModal(true)}
          title="Settings"
          sx={{
            pr: '16px',
            borderRight: '1px solid #475467',
          }}
        >
          <Gear size={20} />
        </IconButtonTooltip>

        <Button
          onClick={() => {
            setFormPreviewOpen(true);
            onSave();
          }}
          variant="text"
        >
          Preview
        </Button>

        <PublishModal
          show={openPublishModal}
          nodes={nodes}
          onHide={() => setOpenPublishModal(false)}
          form={form}
          setUndoRedo={setUndoRedo}
          setForm={setForm}
          hasChanges={hasChanges}
        />

        <AccessModal
          show={openAccessModal}
          onHide={() => setOpenAccessModal(false)}
          form={form}
          setForm={setForm}
        />
        <SettingsModal
          show={openSettingsModal}
          onHide={() => setOpenSettingsModal(false)}
          form={form}
          setForm={setForm}
        />

        <ShareFormModal
          show={openShareModal}
          onHide={() => setOpenShareModal(false)}
          form={form}
        />

        <Button
          onClick={() => {
            setOpenShareModal(true);
            onSave();
          }}
          variant="outlined"
        >
          Share
        </Button>
        <Button
          onClick={() => {
            setOpenPublishModal(true);
            onSave();
          }}
          variant="contained"
        >
          Publish {hasChanges ? 'Changes' : ''}
        </Button>
      </Box>
    </Box>
  );
};

export default FormHeaderTools;
